import type { FC, ReactNode } from 'react';
import type { BoxProps } from '@mui/material';
import { Box, Typography } from '@mui/material';

import { styles } from './index.styles';

export interface ColumnProps extends BoxProps {
  header?: ReactNode;
  data: ReactNode[] | number[] | string[];
  alignment?: 'left' | 'center';
  growing?: boolean;
  rigid?: boolean;
  minWidth?: string;
  maxWidth?: string;
  tinyText?: boolean;
}

const Column: FC<ColumnProps> = ({
  header,
  data,
  alignment = 'center',
  growing = false,
  rigid = false,
  minWidth = 'auto',
  maxWidth = 'auto',
  tinyText = false,
  sx = [],
  ...props
}) => (
  <Box
    className="Column-root"
    sx={[
      styles.dashboardColumn(alignment, growing, rigid),
      { minWidth: minWidth, maxWidth: maxWidth },
      ...(Array.isArray(sx) ? sx : [sx]),
    ].filter(Boolean)}
    {...props}
  >
    <Box className="Column-header" sx={styles.dashboardColumnHeader}>
      {header}
    </Box>

    {data.map((element, index) => (
      <Box
        className="Column-cell"
        key={index}
        sx={[
          styles.dashboardColumnCell,
          tinyText && styles.dashboardColumnCellTiny,
        ].filter(Boolean)}
      >
        {tinyText ? (
          <Typography
            className="Column-cellTiny"
            sx={styles.dashboardColumnCellTiny}
            title={typeof element === 'string' ? element : ''}
          >
            {element}
          </Typography>
        ) : (
          <>{element}</>
        )}
      </Box>
    ))}
  </Box>
);
export default Column;
